// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9ba82492a657469d1305","655":"2f238b02da899769713f"}[chunkId] + ".js";
};